import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import DemoBuilder from "@/pages/DemoBuilder";
export const Route = createFileRoute("/demo")({ head: ({match}) => pageHead(match.pathname), component: () => (<DemoBuilder />) });
